import { type ValidationRule } from '../../types';
import { isExamplePlaceholder } from '../../util/examplePlaceholder';
import { createStepRule, diag } from '../../util/ruleHelpers';

const SOURCE_RULE = 'steps.HaasEndpoint';

// The example corpus elides the cell-specific Haas Ethernet address to a
// placeholder token. The standing placeholder message's remedy (select this
// cell's equipment) does not fit an endpoint string, so the diagnostic
// carries its own.
const HAAS_ENDPOINT_PLACEHOLDER_MESSAGE =
  "This is the example's placeholder endpoint — confirm this cell's Haas Ethernet address.";

/**
 * Placeholder check for the Haas Ethernet address the step args carry.
 * Scoped to the endpoint field only — no other Haas argument validation
 * lives here.
 */
export const HaasEndpointValidation: ValidationRule = createStepRule({
  id: SOURCE_RULE,
  stepKinds: ['HaasControlRegion', 'HaasRunProgram'],
  run: ({ routine, stepId }) => {
    const args = routine.stepConfigurations[stepId]?.args as
      | { address?: { endpoint?: unknown } }
      | undefined;

    const endpoint = args?.address?.endpoint;

    if (!isExamplePlaceholder(endpoint)) return [];

    return [
      diag({
        code: 'ui.examplePlaceholder',
        message: HAAS_ENDPOINT_PLACEHOLDER_MESSAGE,
        stepId,
        fieldId: 'address.endpoint',
        sourceRule: SOURCE_RULE,
        severity: 'error',
      }),
    ];
  },
});
